import React from 'react'
import Helmet from 'react-helmet'
import { modernBrowser } from '../../utils/polyfillUtils'
import { ExternalScriptHead } from '../../hooks/useExternalScriptsHook'
import { SummaryPageNumber } from '../../constants'
import { DownloadFonts } from '@argo/utils'
import { BrowserUtils } from '../../utils/siteUtils'
import CookieHelper from '../../utils/CookieHelper'
const externalScripts = []

export default ({ location, globalState, updateGlobalState, urlState, experienceState, isCatchall, generatedLandingType }) => {
  const isAtc = experienceState.experience === 'atc'
  const reviewStep = urlState && urlState.p === SummaryPageNumber
  const hasGo = urlState && urlState.go
  const initPath = (location && location.initPathParams && location.initPathParams[0]) || ''
  const pathsAndCssOpenSans = fontFaceCssStyles('Open Sans', 'v17', [300, [400, 'regular'], 600, 700])
  const pathsAndCssOpenSansCondensed = fontFaceCssStyles('Open Sans Condensed', 'v14', [300, 700])
  const fontAwesomePath = `${staticFolder}/font/fontello`
  const fontAwesomeMin = getFAString()
  const fontMontserratMin = getMontserratWeights400_500_600_800()
  const preloadFontPaths = [pathsAndCssOpenSans.paths[1], pathsAndCssOpenSans.paths[3]].concat(globalState.interactionReady ? [pathsAndCssOpenSans.paths[2], fontAwesomePath] : [fontAwesomePath])
  const titleStart = isAtc ? 'Instant Cash Offer - Autotrader' : 'Instant Cash Offer - Kelley Blue Book'
  const href = isAtc ? 'https://www.autotrader.com/instant-cash-offer/' : 'https://www.kbb.com/instant-cash-offer/'
  const appScripts = globalState.environment && globalState.environment.optimizelyEnabled ? ['optimizely'] : []
  appScripts.push('audioEye', isAtc ? 'pixallAtc' : 'pixallKbb')
  CookieHelper.set('excludetags', 'foresee|qualtrics|onetrust', 365)

  const hasUrlParams = location && location.pathname?.startsWith('/instant-cash-offer') && location.pathname?.length > 20

  return (
    <>
      <Helmet title={titleStart + (reviewStep ? ' - Review' : '')}>
        <meta
          name="description"
          content={
            isAtc
              ? //These are kept seperate for ease of use. Requirements can change for the different websites.
                'Trade in or sell your car with an official offer based on Kelley Blue Book&reg; Values. Get a free offer in minutes and find out what you can get for your car today.'
              : 'Trade in or sell your car with an official offer based on Kelley Blue Book&reg; Values. Get a free offer in minutes and find out what you can get for your car today.'
          }
        />
        {BrowserUtils.isBrowser && hasUrlParams && !document.querySelector('meta[name="googlebot"]') && <meta name="googlebot" content="noindex, indexifembedded" />}
        {!hasUrlParams && <link rel="canonical" itemProp={!isAtc && 'url'} href={href} />}
        {(process.env.BUILD_STAGE !== 'build-html' || !isCatchall) && <link rel="icon" href={isAtc ? 'https://www.autotrader.com/favicon.ico' : __PATH_PREFIX__ + '/icon.jpg'} />}
        {preloadFontPaths.map((preloadFontPath, i) => (
          <link key={i} rel="preload" as="font" type="font/woff2" href={preloadFontPath + '.woff2'} crossorigin="anonymous" />
        ))}
        <style type="text/css">{minifyCssString(pathsAndCssOpenSans.css + fontAwesomeMin + fontMontserratMin)}</style>
        <style type="text/css">{minifyCssString(pathsAndCssOpenSansCondensed.css)}</style>
        <script type="text/javascript" defer>
          {generateLandingSessionStorageCode(generatedLandingType)}
        </script>
      </Helmet>
      <DownloadFonts />
      <ExternalScriptHead {...{ externalScripts, appScripts, initPath, hasGo, globalState, updateGlobalState }} />
    </>
  )
}

const generateLandingSessionStorageCode = landingType => {
  return BrowserUtils.isSSG && landingType ? (landingType === 'legacy' ? `sessionStorage.removeItem('GeneratedLandingType')` : `sessionStorage.setItem('GeneratedLandingType', '${landingType}')`) : ''
}

const staticFolder = process.env.NODE_ENV === 'production' ? '/instant-cash-offer' : ''
const minifyCssString = css => css.replace(/\n/g, '').replace(/\s\s+/g, ' ')

const fontFaceCssStyles = (fontName, fontVersion, fontWeights, fontCharset) =>
  fontWeights.reduce(
    (pathsAndCss, fontWeight) => {
      const { path, css } = fontFaceCss(fontName, fontVersion, fontWeight, fontCharset)
      pathsAndCss.css += css
      pathsAndCss.paths.push(path)
      return pathsAndCss
    },
    {
      paths: [],
      css: ''
    }
  )
const getFAString = () => {
  return `@font-face {
    font-family: 'fontello';
    src: url('${staticFolder}/font/fontello.eot?81047940');
    src: url('${staticFolder}/font/fontello.eot?81047940#iefix') format('embedded-opentype'), url('${staticFolder}/font/fontello.woff2?81047940') format('woff2'), url('${staticFolder}/font/fontello.woff?81047940') format('woff'), url('${staticFolder}/font/fontello.ttf?81047940') format('truetype'),
      url('${staticFolder}/font/fontello.svg?81047940#fontello') format('svg');
    font-weight: normal;
    font-style: normal;
  }`
}

const getMontserratWeights400_500_600_800 = () => {
  return `@font-face {
    font-family: "Montserrat";
    src: url("${staticFolder}/montserrat/Montserrat-ExtraBold.woff2");
    font-weight: 800;
    font-style: normal;
  }
  @font-face {
    font-family: "Montserrat";
    src: url("${staticFolder}/montserrat/Montserrat-SemiBold.woff2");
    font-weight: 600;
    font-style: normal;
  }
  @font-face {
    font-family: "Montserrat";
    src: url("${staticFolder}/montserrat/Montserrat-Medium.woff2");
    font-weight: 500;
    font-style: normal;
  }
  @font-face {
    font-family: "Montserrat";
    src: url("${staticFolder}/montserrat/Montserrat-Regular.woff2");
    font-weight: 400;
    font-style: normal;
  }
  `
}

//https://google-webfonts-helper.herokuapp.com/fonts/
const fontFaceCss = (fontName, fontVersion, fontWeightInfo, fontCharset = 'latin') => {
  const fontNameNoSpace = fontName.replace(/\s/g, '')
  const fontFamily = fontName.replace(/\s/g, '-').toLowerCase()
  fontWeightInfo = Array.isArray(fontWeightInfo) ? fontWeightInfo : [fontWeightInfo]
  let [fontWeight, fontVariation, fontStyle, fontStyleName] = fontWeightInfo
  fontStyle = fontStyle || fontVariation || 'normal'
  fontVariation = fontVariation || fontWeight
  fontStyleName = fontStyleName || (fontWeight < 400 ? 'Light' : fontWeight < 600 ? 'Regular' : fontWeight < 700 ? 'SemiBold' : 'Bold')
  const folder = `${fontFamily}-${fontVersion}-${fontCharset}`
  const name = `${folder}-${fontVariation}`
  const path = `${staticFolder}/${folder}/${name}`
  return {
    path,
    css: `
@font-face {
  font-family: '${fontName}';
  font-display: swap;
  font-style: ${fontStyle};
  font-weight: ${fontWeight};
  ${modernBrowser ? '' : `src: url('${path}.eot'); `}
  src: local('${fontName} ${fontStyleName}'), local('${fontNameNoSpace}-${fontStyleName}'),
       ${modernBrowser ? '' : `url('${path}.eot?#iefix') format('embedded-opentype'), `}
       ${modernBrowser ? '' : `url('${path}.ttf') format('truetype'), `}
       ${modernBrowser ? '' : `url('${path}.svg#${fontNameNoSpace}') format('svg'), `}
       url('${path}.woff2') format('woff2'),
       url('${path}.woff') format('woff');
}

`
  }
}
